import { searchAPI } from '../API/Seach';
import dayjs from 'dayjs';

/**
 * Helper to perform hotel search and navigate to results page.
 * @param {Object} options
 * @param {number} options.locationId - The location ID to search for.
 * @param {string} options.locationName - The name of the location.
 * @param {function} options.navigate - The navigate function from react-router-dom.
 */
export async function searchHotelsByLocation({ locationId, locationName, navigate }) {
  const userId = parseInt(localStorage.getItem('userId'), 10) || 0;
  const checkIn = dayjs();
  const checkOut = dayjs().add(1, 'day');
  const travelers = {
    adults: 2,
    children: 0,
    rooms: 1,
    childAges: []
  };
  const occupancies = [
    {
      numOfAdults: travelers.adults,
      childAges: travelers.childAges
    }
  ];
  const searchParams = {
    UserId: userId,
    locationId: locationId,
    hotelId: [],
    checkIn: checkIn.format('YYYY-MM-DD'),
    checkOut: checkOut.format('YYYY-MM-DD'),
    occupancies: occupancies,
    filterBy: {
      ratings: [],
      freeBreakfast: false,
      isRefundable: false,
      subLocationIds: [],
      facilities: [],
      type: null,
      tags: [],
      reviewRatings: [],
      minPrice: 0,
      maxPrice: 0
    },
    page: 1,
    traceId: null,
  };
  try {
    const response = await searchAPI.searchHotels(searchParams);
    // Same shape as /api/Hotel/search everywhere else (e.g. SearchSection, SearchResultpage)
    const ok =
      response?.status === "success" &&
      Number(response?.statusCode) === 200;
    if (ok) {
      navigate("/search", {
        state: {
          searchResults: response.data,
          searchParams: {
            location: {
              id: locationId,
              name: locationName,
              fullName: locationName,
              type: "Location",
            },
            checkIn: checkIn.format("YYYY-MM-DD"),
            checkOut: checkOut.format("YYYY-MM-DD"),
            travelers,
          },
        },
      });
    } else {
      throw new Error(response?.message || "Search failed");
    }
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to search hotels. Please try again.";
    alert(msg);
  }
} 